module.exports = __webpack_public_path__ + "static/media/close-plan.e537e61c.svg";